export default "__VITE_ASSET__CtX9SXgK__"